"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//

exports.default = {
  computed: {
    token: function token() {
      return window.globals.csrfToken;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/Token.vue
// module id = REZK
// module chunks = 0 1